var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-unstyled navigation"},_vm._l((_vm.links),function(link,idx){return _c('li',{key:idx,class:{ active: link.active }},[_c('a',{attrs:{"href":link.href}},[_vm._v(_vm._s(link.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }